/* eslint-disable no-alert */
import React, { Component } from 'react'
import _ from 'lodash'
import firebase from 'firebase/app'
import { Button } from 'semantic-ui-react'

export default class SaveSelectedCategories extends Component {
  shouldDisabled = () => {
    const { hasChanged, selected, oldSelected } = this.props

    if (_.size(selected) === 0) return true

    if (!hasChanged) return true

    if (selected !== oldSelected) return false

    return true
  }

  save = async () => {
    const { setSaving, fetchSelectedCategories, selected, selectedCategories } = this.props

    try {
      const conf = window.confirm('Are you sure to make these changes?')
      if (conf) {
        const updates = {}
        const categories = {}

        _.map(selected, (categoryKey, index) => {
          categories[categoryKey] = {
            ...selectedCategories[categoryKey],
            order: index,
          }
        })

        setSaving(true)

        updates.selected_categories = categories

        const err = await firebase
          .database()
          .ref()
          .update(updates)

        if (err) alert(err)

        setSaving(false)
        fetchSelectedCategories()
      }
    } catch (error) {
      setSaving(false)
      alert(error)
    }
  }

  render() {
    const { saving } = this.props

    return (
      <div style={{ marginTop: 20 }}>
        <Button loading={saving} color="black" disabled={this.shouldDisabled()} onClick={this.save}>
          Save
        </Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/category/components/SaveSelectedCategories.js